import React from "react";
import cn from "classnames";
import "./multiSelectWithAddition.scss";
import { MultiSelect, type MultiSelectProps } from "./MultiSelect";

export interface MultiSelectWithAdditionProps<T extends number | string> extends MultiSelectProps<T> {
  id?: string;
  additionLabel?: string;
  additionPosition?: string;
  handleMultiSelectAddition?: (event: React.SyntheticEvent, data: { value: string }) => void;
  handleMultiSelectClick?: (event: React.MouseEvent, data: { value: T }) => void;
  onBlur?: (event: React.FocusEvent) => void;
  renderLabel?: (item: any, index: number, defaultLabelProps: object) => React.ReactNode;
  className?: string;
  noResultsMessage?: string;
  closeOnChange?: boolean;
  openOnFocus?: boolean;
}

function MultiSelectWithAddition<T extends number | string>(props: MultiSelectWithAdditionProps<T>) {
  const {
    id,
    additionLabel,
    additionPosition,
    handleMultiSelectAddition,
    handleMultiSelectClick,
    className,
    ...multiSelectProps
  } = props;

  return (
    <MultiSelect
      id={id}
      className={cn("multi-select-with-addition-control", className)}
      allowAdditions
      additionLabel={additionLabel}
      additionPosition={additionPosition}
      onAddItem={handleMultiSelectAddition}
      onClick={handleMultiSelectClick}
      {...multiSelectProps}
    />
  );
}

MultiSelectWithAddition.defaultProps = {
  additionLabel: "(New Label)",
  additionPosition: "bottom",
  noResultsMessage: "",
  closeOnChange: true,
  openOnFocus: false,
};

export default MultiSelectWithAddition;
